import { CSVRow, loadCSVFromFile } from "../../../lib/csvLoader";
import { 
  ProfilerProductId, 
  ProfilerProduct as Product, 
  ProfilerProductType 
} from "../types/ProfilerProduct";

export class ProductRepository {
  private products: Product[] = [];
  private isInitialized = false;

  constructor() {
    this.initialize();
  }

  async initialize(): Promise<void> {
    if (this.isInitialized) {
      return;
    }

    try {
      const productsData = await loadCSVFromFile("/data/beautyProfilerProducts.csv");
      this.products = productsData.map((row: CSVRow) => ({
        id: parseInt(row.id) as ProfilerProductId,
        label: row.label,
        description: row.description || "",
        type: row.type as ProfilerProductType,
        boost: parseInt(row.boost) as number,
        keywords: row.keywords || "",
        olfactiveNotes: row.olfactiveNotes || "",
      }));

      this.isInitialized = true;
    } catch (error) {
      console.error("Failed to initialize BeautyProfilerProductRepository:", error);
      throw error;
    }
  }

  getProductById(id: ProfilerProductId): Product {
    if (!this.isInitialized) {
      throw new Error(
        "BeautyProfilerProductRepository not initialized. Call initialize() first."
      );
    }
    const product = this.products.find((product) => product.id === id);
    if (!product) {
      throw new Error(`Product with id ${id} not found`);
    }
    return product;
  }

  getProductsByIds(ids: ProfilerProductId[]): Product[] {
    if (!this.isInitialized) {
      throw new Error(
        "BeautyProfilerProductRepository not initialized. Call initialize() first."
      );
    }
    return this.products.filter((product) => ids.includes(product.id));
  }

  getProductsByType(type: ProfilerProductType): Product[] {
    if (!this.isInitialized) {
      throw new Error(
        "BeautyProfilerProductRepository not initialized. Call initialize() first."
      );
    }
    return this.products.filter((product) => product.type === type);
  }

  getAllProducts(): Product[] {
    if (!this.isInitialized) {
      throw new Error(
        "BeautyProfilerProductRepository not initialized. Call initialize() first."
      );
    }
    return [...this.products];
  }

  isReady(): boolean {
    return this.isInitialized;
  }
}

export const beautyProfilerProductRepository = new ProductRepository(); 